import { render, staticRenderFns } from "./join.vue?vue&type=template&id=36cc8fdb&scoped=true&"
import script from "./join.vue?vue&type=script&lang=js&"
export * from "./join.vue?vue&type=script&lang=js&"
import style0 from "./join.vue?vue&type=style&index=0&id=36cc8fdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cc8fdb",
  null
  
)

export default component.exports